<template>
  <v-container>
    <v-row>
      <v-col cols="10"></v-col>
      <v-col cols="1">
        <v-btn @click="downloadCSV" color="primary" icon>
          <v-icon>mdi-file-download</v-icon>
        </v-btn>
      </v-col>
      <!-- <v-col cols="1">
        <v-btn @click="save" color="primary" icon :loading="loading">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-col> -->
      <v-col cols="1">
      </v-col>
    </v-row>
    
    <!-- Contenedor con scroll para la tabla -->
    <div class="table-container">
      <v-data-table
        :headers="c_headers"
        :items="my_rows"
        class="elevation-1 sticky-table"
        disable-pagination
        hide-default-footer
        :height="600"
        fixed-header
      >
        <template v-for="header in c_headers" v-slot:[`header.${header.value}`]="{ header }">
          <span tabindex="0" class="header-content">
            {{ header.text }}
          </span>
        </template>

        <!-- Columnas Personalizables -->
        <template v-for="header in c_headers" v-slot:[`item.${header.value}`]="{ item }">
          <div class="cell-content">
            <span v-if="header.type == 'boolean'">
              <v-checkbox 
                v-model="item[header.value]" 
                :readonly="!editable_fields.includes(header.value)"
                @change="change"
                dense
                hide-details
              >
              </v-checkbox>
            </span>
            <span v-else-if="editable_fields.includes(header.value) && header.type == 'string'" class="editable-field">
              <v-text-field 
                v-model="item[header.value]" 
                dense 
                outlined 
                hide-details
                @input="change"
                class="compact-input"
              ></v-text-field>
            </span>
            <span v-else-if="editable_fields.includes(header.value) && ['number','integer'].includes(header.type)" class="editable-field">
              <v-text-field 
                v-model.number="item[header.value]" 
                dense 
                outlined 
                hide-details
                type="number"
                @input="change"
                class="compact-input"
              ></v-text-field>
            </span>
            <span v-else class="readonly-field">
              {{ item[header.value] }}
            </span>
          </div>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>
  
  <script>
  export default {
    name: "GenericTableEditableComponent",
    props: {
      data: {
        type: Array,
        required: true,
      },
      headers: {
        type: Array,
        default: () => [],
      },
      editable_fields: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        my_rows: this.data,
      };
    },
    mounted() {
      this.my_rows = this.data;
      //set to empty string the null values
      this.my_rows.forEach(row => {
        Object.keys(row).forEach(key => {
          if (row[key] === null) {
            row[key] = "";
          }
        });
      });

    },
    computed: {
      c_headers() {
        if (this.headers.length > 0) {
          return this.headers
        }
        const allKeys = new Set();
        this.data.forEach(row => {
          Object.keys(row).forEach(key => allKeys.add(key));
        });
        return [...allKeys].map(key => ({ text: key, value: key }));
      },
    },
    methods: {
      turnIntoNumber(value) {
        this.data_payload = value !== '' ? Number(value) : null;
        this.change(); // Ensure this is still called
      },
      downloadCSV() {
        const separator = ';';

        const headers = this.headers.map(header => header.text).join(separator);

        const rows = this.my_rows.map(row =>
          this.headers.map(header => {
            let value = row[header.value];

            if (typeof value === 'number') {
              // Convert dot to comma
              return String(value).replace('.', ',');
            }

            if (value == null) {
              return '';
            }

            // Escape quotes for strings
            return `"${value.toString().replace(/"/g, '""')}"`;
          }).join(separator)
        );

        const csvContent = `data:text/csv;charset=utf-8,${headers}\n${rows.join('\n')}`;
        const encodedUri = encodeURI(csvContent);

        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "data.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      change() {
        this.$emit("change", this.my_rows);
      },
    },
  };
</script>

<style scoped>
.table-container {
  max-height:  500px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

/* Estilos para la tabla sticky */
.sticky-table {
  width: 100%;
}

/* Cabecera sticky */
.sticky-table >>> .v-data-table__wrapper {
  overflow: auto;
  max-height: 500px;
}

.sticky-table >>> thead th {
  position: sticky !important;
  top: 0;
  z-index: 10;
  background-color: #f5f5f5 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  min-width: 150px; /* Ancho mínimo para cada columna */
  padding: 12px 16px !important;
}

/* Contenido de las celdas */
.cell-content {
  min-width: 150px;
  padding: 8px;
  display: flex;
  align-items: center;
}

/* Campos editables */
.editable-field {
  width: 100%;
  min-width: 200px;
}

.compact-input {
  min-width: 180px;
}

.compact-input >>> .v-input__control {
  min-height: 36px;
}

.compact-input >>> .v-text-field__details {
  display: none;
}

/* Campos de solo lectura */
.readonly-field {
  padding: 8px 0;
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

/* Contenido del header */
.header-content {
  font-weight: 600;
  color: #424242;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  display: block;
}

/* Scroll horizontal y vertical */
.sticky-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.sticky-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.sticky-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.sticky-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Filas alternadas */
.sticky-table >>> tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.sticky-table >>> tbody tr:hover {
  background-color: #f0f0f0 !important;
}

/* Responsive para pantallas pequeñas */
@media (max-width: 768px) {
  .sticky-table >>> thead th {
    min-width: 120px;
    padding: 8px 12px !important;
  }
  
  .cell-content {
    min-width: 120px;
  }
  
  .editable-field {
    min-width: 150px;
  }
  
  .compact-input {
    min-width: 140px;
  }
}

/* Asegurar que los checkboxes se vean bien */
.sticky-table >>> .v-input--checkbox {
  margin-top: 0;
  padding-top: 0;
}

.sticky-table >>> .v-input--checkbox .v-input__slot {
  margin-bottom: 0;
}
</style>
  